import { useState } from "react";
import useEvaApi, { EvaApiCall } from "../../../hooks/useEvaApi";
import CapacityConfigsPageView from "./CapacityConfigsPageView";
import useCustomEffect from "../../../hooks/useCustomEffect";

function CapacityConfigsPage() {
  const callEvaApi = useEvaApi();

  const [configData, setConfigData] = useState({
    id: null,
    active: false,
    tenant_id: "",
    client_id: "",
    client_secret: "",
    organization_id: "",
    zone_id: "",
    drivertype_id: "",
  });
  const [submitError, setSubmitError] = useState(null);

  /**
   * initialize the component
   */
  useCustomEffect(() => {
    fetchConfigData();
  }, []);

  /**
   * This method will fetch the Azure config data from the API
   */
  async function fetchConfigData() {
    await callEvaApi(
      new EvaApiCall("integrations/capacity/configs")
        .setLoadingGroup("capacity_configs_page_fetch")
        .setAlertError(true)
        .setOnSuccess((response) => {
          const data = response.data.data;
          if (!data) return;

          setConfigData(getConfigDataFromApiResponse(data));
        }),
    );
  }

  /**
   * This method will update the active state on input change
   * @param {bool} value
   */
  function onActiveChange(value) {
    setConfigData({
      ...configData,
      active: value,
    });
  }

  /**
   * This method will update the tenant id on input change
   * @param {event} e
   */
  function onTenantIdChange(e) {
    setConfigData({
      ...configData,
      tenant_id: e.target.value,
    });
  }

  /**
   * This method will update the client id on input change
   * @param {event} e
   */
  function onClientIdChange(e) {
    setConfigData({
      ...configData,
      client_id: e.target.value,
    });
  }

  /**
   * This method will update the client secret on input change
   * @param {event} e
   */
  function onClientSecretChange(e) {
    setConfigData({
      ...configData,
      client_secret: e.target.value,
    });
  }

  /**
   * This method will update the organization id on input change
   * @param {event} e
   */
  function onOrganizationIdChange(e) {
    setConfigData({
      ...configData,
      organization_id: e.target.value,
    });
  }

  /**
   * This method will update the zone id on input change
   * @param {event} e
   */
  function onZoneIdChange(e) {
    setConfigData({
      ...configData,
      zone_id: e.target.value,
    });
  }

  /**
   * This method will update the drivertype id on input change
   * @param {event} e
   */
  function onDriverTypeIdChange(e) {
    setConfigData({
      ...configData,
      drivertype_id: e.target.value,
    });
  }

  /**
   * This method will submit the form
   */
  async function onSubmit() {
    await callEvaApi(
      new EvaApiCall("integrations/capacity/configs")
        .setMethod("PUT")
        .setData(configData)
        .setLoadingGroup("capacity_configs_page_save")
        .setAlertError(true)
        .setErrorState(setSubmitError)
        .setAlertSuccess(true)
        .setOnSuccess((response) => {
          const data = response.data.data;
          if (!data) return;

          setConfigData(getConfigDataFromApiResponse(data));
        }),
    );
  }

  /**
   * This method will map the API response to the config data structure
   * @param {object} data
   * @returns {object}
   */
  function getConfigDataFromApiResponse(data) {
    return {
      id: data.id,
      active: data.active,
      tenant_id: data.tenant_id,
      client_id: data.client_id,
      client_secret: data.client_secret,
      organization_id: data.organization_id,
      zone_id: data.zone_id,
      drivertype_id: data.drivertype_id,
    };
  }

  return (
    <CapacityConfigsPageView
      configData={configData}
      submitError={submitError}
      setConfigData={setConfigData}
      onSubmit={onSubmit}
      onActiveChange={onActiveChange}
      onTenantIdChange={onTenantIdChange}
      onClientIdChange={onClientIdChange}
      onClientSecretChange={onClientSecretChange}
      onOrganizationIdChange={onOrganizationIdChange}
      onZoneIdChange={onZoneIdChange}
      onDriverTypeIdChange={onDriverTypeIdChange}
    />
  );
}

export default CapacityConfigsPage;
